import React from 'react';
import { FaStar, FaStarHalfAlt, FaRegStar } from 'react-icons/fa';

/**
 * A reusable component for displaying star ratings
 * @param {Object} props - Component props
 * @param {number} props.rating - The rating value (0-5)
 * @param {boolean} props.showValue - Whether to show the numerical value
 * @param {boolean} props.showCount - Whether to show the review count
 * @param {number} props.count - The number of reviews
 * @param {string} props.className - Additional CSS class name
 * @param {string} props.source - The source of the rating (e.g., "Google reviews")
 */
const RatingStars = ({ rating, showValue = true, showCount = false, count = 0, className = '', source = '' }) => {
  return (
    <div className={`rating-display ${className}`}>
      <div className="rating-stars">
        {[...Array(5)].map((_, i) => {
          const ratingValue = i + 1;
          if (ratingValue <= rating) {
            return <FaStar key={i} className="star filled" />;
          } else if (ratingValue <= rating + 0.5) {
            return <FaStarHalfAlt key={i} className="star half-filled" />;
          } else {
            return <FaRegStar key={i} className="star" />;
          }
        })}
      </div>
      
      {showValue && <span className="rating-value">{rating.toFixed(1)}</span>}
      
      {(showCount || source) && (
        <div className="rating-details">
          {source && <span className="rating-source">based on {source}</span>}
          {showCount && <span className="rating-count">({count} reviews)</span>}
        </div>
      )}
    </div>
  );
};

export default RatingStars; 